import { render } from "./FormSubmitInput.vue?vue&type=template&id=1b90a170"
import script from "./FormSubmitInput.vue?vue&type=script&lang=js"
export * from "./FormSubmitInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__